import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { closeModal, openModal } from '../../../../redux/modals/action';
import Modal from '../../../layout/modal/Modal';
import styles from './AuditTrailModal.module.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import dayjs from 'dayjs';
import EmailIcon from '@mui/icons-material/Email';
import CreateIcon from '@mui/icons-material/Create';
import { Grid } from '@mui/material';
import { humanizer } from '../../../../utils/snakeCaseToHumanize';
import ClearIcon from '@mui/icons-material/Clear';

const AuditTrailModal = ({ showModal, closeModal, openModal, auditTrail }) => {
	const handleCloseAuditTrail = () => {
		openModal('clientDetails');
	};

	const headers = [
		{ id: 'status', name: 'Status' },
		{ id: 'time', name: 'Time' },
		{ id: 'user', name: 'User' },
		{ id: 'log', name: 'Log' },
	];

	useEffect(() => {
		console.log('Audit trail time stamp', auditTrail?.timestamps);

		auditTrail?.timestamps?.sort((a, b) => a?.timestamp - b?.timestamp);

		console.log('Audit trail time stamp', auditTrail?.timestamps);
	}, [auditTrail]);

	return (
		<div className={styles.auditTrailModal}>
			<Modal
				show={showModal}
				close={() => handleCloseAuditTrail()}
				title={'Audit Trail'}
			>
				<Table>
					<TableHead>
						<TableRow>
							{headers.map((header) => (
								<TableCell
									key={header.id}
									className={styles.header}
								>
									{header.name}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{auditTrail ? (
							<>
								{auditTrail?.timestamps
									?.sort(
										(a, b) => a?.timestamp - b?.timestamp
									)
									?.map((trail) => {
										var status;
										var log;

										console.log('traoiijoil', trail);

										if (
											trail.type ===
											'signature_request_sent'
										) {
											status = {
												name: 'Sent',
												icon: <EmailIcon />,
											};
										} else if (
											trail.type ===
											'signature_request_signed'
										) {
											status = {
												name: 'Signed',
												icon: <CreateIcon />,
											};
										} else if (
											trail.type ===
											'signature_request_canceled'
										) {
											status = {
												name: 'Cancelled',
												icon: <ClearIcon />,
											};
										}

										if (
											trail.type ===
											'signature_request_sent'
										) {
											log = 'Sent for signature to';
										} else if (
											trail?.signatures?.statusCode ===
											'signed'
										) {
											log = 'Signed by';
										} else if (
											trail?.signatures?.statusCode ===
											undefined
										) {
											log = 'Signature Request Cancelled';
										}

										console.log('suajfafaf', status, log);
										return (
											<TableRow>
												<TableCell>
													<div
														container
														className={
															styles.status
														}
													>
														<div>
															{status.icon}{' '}
															<span>
																{status.name}
															</span>
														</div>
													</div>
												</TableCell>
												<TableCell>
													{dayjs(
														trail.timestamp * 1000
													).format(
														'DD MMM, YYYY, HH:mm'
													)}
												</TableCell>
												<TableCell>
													{
														trail?.signatures
															?.signerRole
													}
												</TableCell>
												<TableCell width={500}>
													{`${log}  ${
														trail?.signatures
															?.signerName || ''
													}`}
												</TableCell>
											</TableRow>
										);
									})}
							</>
						) : (
							<div className={styles.empty_handler}>
								No information is being displayed yet.
							</div>
						)}
					</TableBody>
				</Table>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	auditTrail: state.purchasers?.auditTrail,
});

export default connect(mapStateToProps, { closeModal, openModal })(
	AuditTrailModal
);
